import { App, ConfigProvider } from 'antd';
import sk_SK from 'antd/locale/sk_SK';
import { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import { Utils } from '../common/components';
import { registerMessageApi } from '../common/services/message';
import theme from './theme';
import ProtectedRoute from '../common/guards/AuthGuard';
import AuthFeature from '../features/auth';
import FormFeature from '../features/form';
import HomeFeature from '../features/home';

import ErrorBoundary from './components/ErrorBoundary';
import { ScrollToTop } from './components/ScrollToTop';

import { store, initStore } from './store/configure-store';

function MessageBridge() {
  const { message } = App.useApp();

  useEffect(() => {
    registerMessageApi(message);
  }, [message]);

  return null;
}

export default function Root() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    initStore().then(() => {
      setReady(true);
    });
  }, []);

  function renderEmpty() {
    return <Utils.Empty />;
  }

  return (
    <ConfigProvider theme={theme} renderEmpty={renderEmpty} locale={sk_SK}>
      <App>
        <MessageBridge />
        <Provider store={store}>
          <ErrorBoundary>
            {ready ? (
              <BrowserRouter>
                <ScrollToTop>
                  <Routes>
                    <Route path="auth/*" element={<AuthFeature />} />
                    <Route element={<ProtectedRoute />}>
                      <Route path="home/*" element={<HomeFeature />} />
                      <Route path="form/:id/*" element={<FormFeature />} />
                    </Route>
                    <Route path="*" element={<Navigate to="/home" replace />} />
                  </Routes>
                </ScrollToTop>
              </BrowserRouter>
            ) : (
              <div />
            )}
          </ErrorBoundary>
        </Provider>
      </App>
    </ConfigProvider>
  );
}
